module.exports = __webpack_public_path__ + "img/同兴庄园.14f313f8.png";